var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerticalTripleLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 16,
    viewBox: "0 0 6 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.99992 4.33333C4.19654 4.33333 5.16659 3.36328 5.16659 2.16667C5.16659 0.97005 4.19654 0 2.99992 0C1.8033 0 0.833252 0.97005 0.833252 2.16667C0.833252 3.36328 1.8033 4.33333 2.99992 4.33333Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.99992 10.1668C4.19654 10.1668 5.16659 9.19678 5.16659 8.00016C5.16659 6.80355 4.19654 5.8335 2.99992 5.8335C1.8033 5.8335 0.833252 6.80355 0.833252 8.00016C0.833252 9.19678 1.8033 10.1668 2.99992 10.1668Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.99992 15.9998C4.19654 15.9998 5.16659 15.0298 5.16659 13.8332C5.16659 12.6366 4.19654 11.6665 2.99992 11.6665C1.8033 11.6665 0.833252 12.6366 0.833252 13.8332C0.833252 15.0298 1.8033 15.9998 2.99992 15.9998Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticalTripleLine);
export default __webpack_public_path__ + "static/media/vertical-triple-line.1873eeb12d42eed57d5dbd12d970f844.svg";
export { ForwardRef as ReactComponent };